import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import React, { useState } from 'react'
import styles from './styles.module.css'
import ArrowRight from '../../../icons/ArrowRight'
import CtaV2 from '../../../CtaV2'
import Spacer from '../../../Spacer'
import Text from '../../../Text'
import WarningIcon from '../../../icons/WarningIcon'
import { $red50 } from '../../../../styles/colors/primitives'
import { useRegionOffers } from '../../../RegionOffers'
import { useCartStore, selectCart } from '../../../../store/cartStore'
import { useSessionStore } from '../../../../store/sessionStore'
import { getWebAppUrl } from '../../../../utils/payments/payments'
import { pushEcommerceEvent, buildEcommercePayload } from '../../../../utils/dataLayer'

export const CheckoutForm = ({ isLive }) => {
  const stripe = useStripe()
  const elements = useElements()
  // Cart line items now come from the Zustand cart store (Bucket C); discountCode +
  // paymentStartedInfo from the Zustand session store (Phase C2 part 1). Offers moved
  // to the RegionOffers seam (Phase D1).
  const { offers } = useRegionOffers()
  const shoppingCart = useCartStore(selectCart)
  const discountCode = useSessionStore((s) => s.discountCode)
  const paymentStartedInfo = useSessionStore((s) => s.paymentStartedInfo)

  const [error, setError] = useState(null)

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault()

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // TODO: Make sure to disable form submission until Stripe.js has loaded.
      return
    }

    // NOTE: using actions before confirm payment to reset shopping cart broke the code for an unknown reason

    const cartEntries = Object.keys(shoppingCart || {})
      .map(id => ({ item: offers && offers.find(i => i.id === id), quantity: shoppingCart[id] }))
      .filter(entry => entry.item)
    pushEcommerceEvent('add_payment_info', {
      ...buildEcommercePayload(cartEntries),
      payment_type: 'stripe',
      coupon: discountCode || undefined,
    })

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: `${getWebAppUrl(isLive)}/product/order-confirmation?region=${paymentStartedInfo.region}&provider=${paymentStartedInfo.provider}&relatedPaymentId=${paymentStartedInfo.relatedPaymentId}`,
      },
    })

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      setError(result.error.message)
    } else {
      setError(null)
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  }

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <PaymentElement options={{
        layout: 'accordion'
      }}/>
      <Spacer size={24}/>
      { error && (
        <>
          <div className={styles.error} style={{ color: $red50 }}>
            <WarningIcon color={$red50}/>
            <Text type="regular">{error}</Text>
          </div>
          <Spacer size={8}/>
        </>
      )}
      <CtaV2
        title="Submit"
        titleIcon={<ArrowRight/>}
        dark
        type="submit"
        isLoading={false}
        disabled={false}
        sx={{
          height: '80px',
          width: '100%',
          titleTextType: 'large'
        }}
      />
    </form>
  )
}
